import axios from 'axios';
import './httpNotify';

export default {
    init(baseUrl) {
        axios.defaults.baseURL = baseUrl.length ? baseUrl : '/vms-api/';
    },

    get(url, config) {
        return axios.get(
            url,
            this.parseHttpConfig({ notifySuccess: false, ...config })
        );
    },

    post(url, data, config) {
        return axios.post(
            url,
            data,
            this.parseHttpConfig({ notifySuccess: true, ...config })
        );
    },

    patch(url, data, config) {
        return axios.patch(
            url,
            data,
            this.parseHttpConfig({ notifySuccess: true, ...config })
        );
    },

    put(url, data, config) {
        return axios.put(
            url,
            data,
            this.parseHttpConfig({ notifySuccess: true, ...config })
        );
    },

    delete(url, data, config) {
        // note Axios delete method does not support data parameter
        // to set body data use the config.
        return axios.delete(url, {
            data: data,
            ...this.parseHttpConfig({ notifySuccess: true, ...config })
        });
    },

    // ====== Auth information that will be injected into the header
    auth: {
        userToken: '',
        mso: '',
        partner: '',
        venue: ''
    },
    setAuthInfo(token, mso, partner, venue) {
        this.auth.userToken = token;
        this.auth.mso = mso;
        this.auth.partner = partner;
        this.auth.venue = venue;
    },

    // ====== these are the internal hooks that get called from the interceptor
    hooks: {
        requestPendingFn: () => {
            console.log('*** notify request pending ***');
        },
        requestStartFn: () => {
            console.log('*** notify request started ***');
        },
        requestCompleteFn: () => {
            console.log('*** notify request done ***');
        },
        responseSuccessFn: message => {
            console.log('*** notify response success ***', message);
        },
        responseErrorFn: message => {
            console.log('*** notify response error ***', message);
        },
        responseUnauthorizedFn: () => {
            console.log('*** notify response unauthorized ***');
        }
    },
    // use these function to register custom hooks by passing a handler function
    requestPending(handler) {
        // register the handler for this hook
        if (handler && handler instanceof Function) {
            this.hooks.requestPendingFn = handler;
        }
    },
    requestStart(handler) {
        // register the handler for this hook
        if (handler && handler instanceof Function) {
            this.hooks.requestStartFn = handler;
        }
    },
    requestComplete(handler) {
        // register the handler for this hook
        if (handler && handler instanceof Function) {
            this.hooks.requestCompleteFn = handler;
        }
    },
    responseSuccess(handler) {
        if (handler && handler instanceof Function) {
            this.hooks.responseSuccessFn = handler;
        }
    },
    responseError(handler) {
        if (handler && handler instanceof Function) {
            this.hooks.responseErrorFn = handler;
        }
    },
    responseUnauthorized(handler) {
        if (handler && handler instanceof Function) {
            this.hooks.responseUnauthorizedFn = handler;
        }
    },
    // ============ Helper method to parse the config and inject auth variables ==========
    parseHttpConfig(config) {
        let ajaxConfig = {};
        // controls the ui notifications behavior
        // this.auth: should contain login info to be injected into the header
        ajaxConfig = {
            notifyError: true,
            notifySuccess: false,
            notifyRequestPending: false,
            successMessage: null,
            errorMessage: null,
            headers: {},
            hooks: this.hooks,
            ...config
        };

        if (!config.suppressAuth) {
            ajaxConfig.headers['user-token'] = this.auth.userToken;
        }

        if (!config.suppressVenue) {
            ajaxConfig.headers['mso'] = this.auth.mso;
            ajaxConfig.headers['partner'] = this.auth.partner;
            ajaxConfig.headers['venue'] = this.auth.venue;
        }

        return ajaxConfig;
    }
};
